import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const templateEditorStyles: IStyles = {
    root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
        boxSizing: 'border-box',
        background: color.bgWhiteTertiary,
    },
    body: {
        display: 'flex',
        flex: 1,
        minHeight: 0,
    },
    toast: {
        position: 'absolute',
        left: '50%',
        bottom: 24,
        transform: 'translateX(-50%)',
        zIndex: 40,
        maxWidth: 'min(420px, calc(100% - 32px))',
        padding: '10px 14px',
        borderRadius: 10,
        background: color.fontDarkUltraHigh,
        color: color.fontWhiteUltraHigh,
        fontSize: 13,
        lineHeight: 1.35,
        textAlign: 'center',
        boxShadow: `0 8px 24px ${color.bgAlphaDark50}`,
        pointerEvents: 'none',
    },
}

addStyles(templateEditorStyles)
export default templateEditorStyles
